module.exports = function MString(val) {
    var self = this;
    
    this.value = val === undefined ? '' : '' + val;
    
    this.getDetails = function() {
        return {
            type : 'string',
            name : 'string',
            default : self.value
        };
    };
    
    this.parse = function(buffer) {
        return buffer.toString();
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/metadata/string.js
// module id = 294
// module chunks = 1